import React, { useState, memo } from 'react';
import { connect } from 'react-redux';

import connectOptions, { mergeProps } from '../../utils/connectOptions';
import SaveQueryPopup from '../../components/Popup/SaveQueryPopup';
import { usePopupContext } from '../../contexts/PopupContext';

const SaveQueryPopupContainer = ({ popup }) => {
  const { closePopup } = usePopupContext();
  const [queryName, setQueryName] = useState('');

  const handleChange = event => {
    const {
      target: { value },
    } = event;

    setQueryName(value);
  };

  const isDisabled = queryName.trim() === '';

  const handleAddSaveQuery = () => {
    if (queryName) {
      const onAddSaveQuery = popup.getIn(['props', 'onAddSaveQuery']);

      onAddSaveQuery(queryName);
    }
  };

  const handleClose = () => {
    closePopup();
  };

  return (
    <SaveQueryPopup
      isDisabled={isDisabled}
      isPopupFetching={popup.get('isPopupFetching')}
      isPopupFetchingError={popup.get('isPopupFetchingError')}
      onAddSaveQuery={handleAddSaveQuery}
      onChange={handleChange}
      onClose={handleClose}
    />
  );
};

export { SaveQueryPopupContainer };
export default connect(() => ({}), {}, mergeProps, connectOptions)(memo(SaveQueryPopupContainer));
